
import { Fragment, useEffect, useState } from 'react';

import classes from './PassKeyNamePopup.module.scss';
import passkeyImg from '../../../../assets/img/passkey.svg';
import alert from '../../../../assets/icons/alert-circle-red.svg';

declare function Translate(key: string): string;

const PassKeyNamePopup = (props) => {

    const [passkeyName,setPasskeyName] = useState('');
    const [pkDirty,setPkDirty] = useState(false);
    const [isNameValid,setIsNameValid] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [expiryDate, setExpiryDate] = useState('');

    useEffect(() => {
        document.getElementById('pkName')?.focus();
        const d = new Date();
        let year = d.getFullYear() + 1;
        let month = d.getMonth() + 1;
        let day = d.getDate();
        setExpiryDate(`${day}/${month}/${year}`);                
    },[]);

    const handleSavelick = () => {                
        props.saveName(passkeyName);
    };

    const handleSavePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
          handleSavelick();
        }        
    };

    const handleEscape = (event) => {       
        if (event.keyCode === 27){
            props.close();
        }
    };

    const handleNameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {     
      setErrorMsg('');

      if(!pkDirty){
        setPkDirty(true);
      }

      const regex = new RegExp(/^[\p{L}\p{N}\s.\-_:]{1,64}$/u);      
      if (regex.test(e.target.value)){               
        setPasskeyName(e.target.value);
        if(e.target.value.length > 1){
            setIsNameValid(true);
        }
        else{
            setIsNameValid(false);
        }
      }
      else{                
        if(e.target.value.length === 0){
          setPasskeyName(e.target.value);
          setIsNameValid(false);
          setErrorMsg(Translate('N_General_Error_Mandatory_Field')); 
        }        
      }                                            
    }

    const handleNameEnter = (event) => {
        if (event.charCode === 13){
            handleSavelick();           
        }
    };
   
    
    return(
       <Fragment >
            <div id='popupContainer' 
                    tabIndex={0} 
                    className={classes.popup_box} 
                    role="dialog" 
                    aria-labelledby="popupTitle" 
                    aria-describedby="popupDesc"
                    onKeyDown={handleEscape}
            >
                <div>
                   <img className={classes.title_img} src={passkeyImg} /> 
                </div>
                <div className={classes.popup_title} id='popupTitle' role="heading" aria-level={2}>
                    {Translate('N_Login_Pk_Mobile_Enrolled')}                   
                </div>               
                <div className={classes.main}>
                    <div className={classes.input_container}>
                        <label htmlFor="pkName" className={classes.pkn_label}>{Translate('N_Login_Pk_Mobile_Name')}</label>
                        <input 
                            type="text"
                            id='pkName'
                            value={passkeyName}
                            onChange={handleNameChanged}
                            onKeyPress={handleNameEnter} 
                            placeholder={Translate('N_Login_Pk_Mobile_Name_Placeholder')}                                       
                            className={
                            `
                                form-control ${classes.pkn_input}                                         
                                ${!isNameValid && passkeyName.length === 0 && pkDirty ? 'error-control' : ''}                             
                            `                    
                            }
                        />
                    </div>
                    {!isNameValid && passkeyName.length === 0 && pkDirty && (
                        <div className={classes.error_row}>
                            <img src={alert} alt='' className='error-alert' aria-hidden="true"/>
                            &nbsp;
                            <span className={classes.error_text}>                         
                                {errorMsg}
                            </span>
                        </div>
                    )}
                    <div className={classes.pkn_desc}>
                        <div className={classes.pkn_desc_icon}>
                            <span className={classes.pkn_desc_icon_text}>i</span>
                        </div>
                        <span className={classes.pkn_desc_text}>{Translate('N_Login_Pk_Mobile_Name_desc')}</span>
                    </div>
                    <div className={classes.warning_container}>
                        <div className={classes.warning_title_container}>                           
                            <div className={classes.warning_icon}>
                                <span className={classes.pkn_desc_icon_text}>i</span>
                            </div>
                            <div className={classes.warning_title}>
                                {Translate('N_General_Attention')}                                
                            </div>                            
                        </div>
                        <div className={classes.warning_desc_container}>
                            <div className={classes.warning_desc}>
                                <div>
                                    <span>{Translate('N_Login_Pk_Expiry_Connection_1')}</span>
                                    <span className={classes.expiry_date}>{expiryDate}</span>
                                </div>
                                <div>
                                    <span>{Translate('N_Login_Pk_Expiry_Connection_2')}</span>
                                </div>                                
                            </div>
                            <div className={classes.warning_desc_bold}>
                                {Translate('N_General_Password_Security')}
                            </div>
                        </div>
                    </div>

                    <div className={classes.btn}>
                        <button 
                            id='btnPkNameSave'
                            className={classes.popup_button}
                            onClick={handleSavelick}
                            onKeyPress={handleSavePress}
                            disabled = {!isNameValid}
                            tabIndex={0}
                        >
                            {Translate('N_General_Save')}                           
                        </button>                    
                    </div> 
                </div>               
            </div>
       </Fragment>

       
    );
};
export default PassKeyNamePopup;
